import { Tag, Tooltip } from 'antd';
import { resolveDynamicOrStaticProperty } from 'lib/utils/dynamic-or-static-property';
import { useCallback } from 'react';
import { BaseTableUserRecord, UserListProps } from '../user-table-types';

const UserStatusConfig = {
  pending: {
    title:
      'The user has been invited to the organisation but has not accepted their invitation',
    tagColor: 'geekblue',
    shortText: 'Invite Pending'
  },
  accepted: {
    title: 'The user has accepted their invitation',
    tagColor: 'green',
    shortText: 'Invite Accepted'
  }
};

/**
 * User status column
 */

export function useResolveStatusColumnData<T extends BaseTableUserRecord>(
  props: UserListProps<T>
) {
  return useCallback(
    (_val, record) => {
      /**
       * Generate the list of visible status options
       */
      const visiblestatusOptions =
        props.extraStatus?.filter(
          _ =>
            _.shouldShow === undefined ||
            resolveDynamicOrStaticProperty(_.shouldShow, record)
        ) ?? [];

      const resolvedArr = visiblestatusOptions.map(_ => {
        const name = resolveDynamicOrStaticProperty(_.name, record);
        return (
          <Tooltip title={_.toolTip} key={name}>
            {/* <li> */}
            <Tag>{name}</Tag>
            {/* </li> */}
          </Tooltip>
        );
      });

      const userStatus =
        UserStatusConfig[record.invitePending ? 'pending' : 'accepted'];

      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {/* <ul> */}
          {[
            <Tooltip title={userStatus.title} key={1}>
              {/* <li> */}
              <Tag color={userStatus.tagColor} style={{ padding: '0.1rem' }}>
                {userStatus.shortText}
              </Tag>
              {/* </li> */}
            </Tooltip>,
            ...resolvedArr
          ]}
          {/* </ul> */}
        </div>
      );
    },
    [props.extraStatus]
  );
}
